import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { createMask } from '@ngneat/input-mask';
import { ImageModel } from 'src/app/models/common/image.model';
import { NewsEditModel } from 'src/app/models/news/news-edit.model';
import { ApiService } from 'src/app/services/api.service';
import { BasePage } from '../base-page';
import { MessageService } from 'src/app/services/message.service';
import { NgbDate, NgbDateStruct, NgbTimeStruct } from '@ng-bootstrap/ng-bootstrap';
import { parseDate, parseTime } from 'src/app/helpers/date-time';

@Component({
    selector: 'app-edit-news',
    templateUrl: './edit-news.component.html',
    styleUrls: ['./edit-news.component.scss'],
    standalone: false
})
export class EditNewsComponent extends BasePage implements OnInit {

  public dateMask = createMask<string>({
    alias: 'datetime',
    inputFormat: 'dd.mm.yyyy HH:MM',
    placeholder: '_',
    parser: (value: string) => {
      const parts = value.split(' ');

      const date = parts[0].split('.');
      const year = +date[2];
      const month = +date[1] - 1;
      const day = +date[0];

      const time = parts[1].split(':');
      const hours = +time[0];
      const min = +time[1];

      const dateTime = new Date(year, month, day, hours, min);
      return dateTime.getUTCFullYear() + '-' + this.numDate(dateTime.getUTCMonth() + 1) + '-' + this.numDate(dateTime.getUTCDate()) + 'T' + this.numDate(dateTime.getUTCHours()) + ':' + this.numDate(dateTime.getUTCMinutes()) + ':00.000';
    },
  });

  public selectedStartDate?: NgbDateStruct;
  public selectedEndDate?: NgbDateStruct;

  public selectedStartTime: NgbTimeStruct = { hour: 0, minute: 0, second: 0 };
  public selectedEndTime: NgbTimeStruct = { hour: 0, minute: 0, second: 0 };

  public model: NewsEditModel = { isPublished: true, id: '', images: [], title: '' };

  public constructor(private mApiService: ApiService, private mRouter: Router, activatedRoute: ActivatedRoute, private mMessageService: MessageService) {
    super();
    this.model.id = activatedRoute.snapshot.params['id'] !== 'new' ? activatedRoute.snapshot.params['id'] : undefined;
  }

  ngOnInit(): void {
    if (this.model.id) {
      this.mApiService.get<NewsEditModel>(`/api/admin/news/${this.model.id}`).subscribe({
        next: r => {
          this.model = r;
          this.setDates();
          this.isBusy = false;
        },
        error: () => {
          this.isBusy = false;
        }
      });
    } else {
      this.isBusy = false;
    }
  }

  public save() {
    this.isBusy = true;

    if (this.selectedStartDate) {
      this.model.startDateUtc = this.prepareDateToUtc(this.selectedStartDate, this.selectedStartTime);
    }

    if (this.selectedEndDate) {
      this.model.endDateUtc = this.prepareDateToUtc(this.selectedEndDate, this.selectedEndTime);
    }

    this.mApiService.post<NewsEditModel, NewsEditModel>('/api/admin/news', this.model).subscribe({
      next: r => {
        this.isBusy = false;

        if (!this.model.id) {
          this.mRouter.navigate([`/news/edit/${r.id}`]);
        }

        this.model = r;
        this.setDates();

        this.mMessageService.addMessage({
          text: 'Новость сохранена',
          type: this.mMessageService.types.success
        }, true);
      }, error: () => this.isBusy = false
    });
  }

  public selectFile(event: any) {
    if (!event.target.files[0]) {
      return;
    }

    const formData = new FormData();
    formData.append('file', event.target.files[0]);
    formData.append('order', '1');
    this.isBusy = true;

    this.mApiService.formData<ImageModel>('/api/admin/news/image/save', formData).subscribe({
      next: (r) => {
        if (!this.model.images) {
          this.model.images = [];
        }
        this.model.images.push(r);
        this.isBusy = false;
      },
      error: () => this.isBusy = false
    });
  }

  public removeImage(image: ImageModel) {
    this.model.images?.splice(this.model.images?.indexOf(image), 1);
  }

  public override back(): void {
    this.mRouter.navigateByUrl('/news');
  }

  private prepareDateToUtc(date: NgbDateStruct, time: NgbTimeStruct) {
    const dateTime = new Date(date.year, date.month - 1, date.day, time.hour, time.minute);
    return dateTime.getUTCFullYear() + '-' + this.numDate(dateTime.getUTCMonth() + 1) + '-' + this.numDate(dateTime.getUTCDate()) + 'T' + this.numDate(dateTime.getUTCHours()) + ':' + this.numDate(dateTime.getUTCMinutes()) + ':00.000';
  }

  private numDate(num: number) {
    return num < 10 ? '0' + num : num.toString();
  }

  private setDates() {
    if (this.model.startDateUtc) {
      this.selectedStartDate = parseDate(this.model.startDateUtc);
      this.selectedStartTime = parseTime(this.model.startDateUtc)!;
    }

    if (this.model.endDateUtc) {
      this.selectedEndDate = parseDate(this.model.endDateUtc);
      this.selectedEndTime = parseTime(this.model.endDateUtc)!;
    }
  }
}
